import React from 'react'
import LaborRole from '../components/production/laborRole/LaborRole'

export default function LaborRolePage() {
  return <LaborRole />
}
